import { Navbar, Nav, Container, Offcanvas, Button } from "react-bootstrap";
import "react-phone-input-2/lib/style.css";

import { useFaqItems } from "./FAQItems";
import FAQItem from "./FAQItem";

// router
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";

import letterLogo from "../../assets/images/letter-logo.webp";
import topLogo from "../../assets/images/top-logo.webp";
import learnmoreSmallTopBg from "../../assets/images/learnmore-top-small-bg.webp";

import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../../components/LanguageSelector";

const LearnMore = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const faqItems = useFaqItems();
  const handleLogoClick = () => {
    navigate("/landing-page");
  };

  return (
    <div className="learnmore-bg">
      <Navbar expand="lg" className="px-3 pt-3">
        <Container fluid>
          {/* Left: Logo */}
          <Navbar.Brand onClick={handleLogoClick} style={{ cursor: "pointer" }}>
            <img
              src={topLogo}
              alt="Logo"
              width="160"
              height="40"
              className="d-inline-block align-center"
            />
          </Navbar.Brand>
          <span className="d-flex gap-3">
            <span className="d-block d-lg-none">
              <LanguageSwitcher />
            </span>
            <Navbar.Toggle
              aria-controls="offcanvasNavbar-expand"
              style={{ fontSize: "1rem", padding: "5px 7px" }}
            />
            <Navbar.Offcanvas
              id="offcanvasNavbar-expand"
              aria-labelledby="offcanvasNavbarLabel-expand"
              placement="end" // Right side
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id="offcanvasNavbarLabel-expand">
                  {t("Menu")}
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                {/* Center-Right: Menu Items */}
                <Nav className="ms-auto me-3">
                  <Button
                    className="rounded-pill py-1 d-none d-lg-block"
                    style={{
                      backgroundColor: "#ede7e7",
                      color: "gray",
                      borderColor: "#ede7e7",
                      paddingRight: "40px",
                      paddingLeft: "40px",
                    }}
                    onClick={() =>
                      window.open(
                        "https://www.gofundme.com/f/heroinvoice-die-faire-erechnungslosung-fur-kleinunternehm",
                        "_blank",
                      )
                    }
                  >
                    {t("Donate")}
                  </Button>
                  <Nav.Link
                    as={Link}
                    to="/about-us"
                    className="top-menu-text-color"
                  >
                    {t("ABOUT US")}
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/learn-more"
                    className="top-menu-text-color"
                  >
                    {t("LEARN MORE")}
                  </Nav.Link>
                </Nav>

                {/* Right: Button */}

                <Button
                  className="rounded-pill py-1 d-block d-lg-none my-3 w-100"
                  style={{
                    backgroundColor: "#ede7e7",
                    color: "gray",
                    borderColor: "#ede7e7",
                    paddingRight: "40px",
                    paddingLeft: "40px",
                  }}
                  onClick={() =>
                    window.open(
                      "https://www.gofundme.com/f/heroinvoice-die-faire-erechnungslosung-fur-kleinunternehm",
                      "_blank",
                    )
                  }
                >
                  {t("Donate")}
                </Button>
                <Button
                  className="rounded-pill px-3 py-1 d-none d-lg-block"
                  style={{ backgroundColor: "#1e587e", borderColor: "white" }}
                  onClick={() => {
                    navigate("/auth-register");
                  }}
                >
                  {t("Try out for free")}
                </Button>

                {/* <LanguageSwitcher /> */}
                <Button
                  className="rounded-pill px-3 py-1 w-100 d-block d-lg-none"
                  style={{ backgroundColor: "#1e587e", borderColor: "white" }}
                  onClick={() => {
                    navigate("/auth-register");
                  }}
                >
                  {t("Try out for free")}
                </Button>
                <span className="d-none d-lg-block">
                  <LanguageSwitcher />
                </span>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </span>
        </Container>
      </Navbar>

      <div className="section wrapper1">
        <div className="w-half">
          <h1 className="main-title">{t("All facts")}</h1>
          <div className="d-flex align-items-end">
            <h1 className="sub-main-title">{t("about")}</h1>
            <img src={letterLogo} alt="Logo" className="letter-logo" />
          </div>
          <div className="aboutus-image-container">
            <div className="learnmore-text-overlay">
              <p style={{ fontWeight: "600" }} className="mt-3">
                {t("Got questions?")}
              </p>
              <p style={{ fontWeight: "600" }}>
                {t("We’ve (usually) got the answers!")}
              </p>
              <p style={{ fontWeight: "600" }}>
                {t(
                  "This is where you’ll find everything you need to know about Hero-Invoice – from features and pricing to data protection and support. And if you’re still unsure about something, just drop us a message. We’re here for you – fast, friendly, and a little bit heroic.",
                )}
              </p>
              <div
                className="d-flex justify-content-center"
                style={{ marginTop: "30px" }}
              ></div>
            </div>
          </div>
        </div>
        <div className="w-half">
          <img src={learnmoreSmallTopBg} className="top-bg img-responsive" />
        </div>
      </div>
      <Container className="learnmore-top px-4 px-lg-0">
        <div className="px-2">
          <h1 className="learnmore-fqa-title">
            {t("Frequently Asked Questions (FAQ) for Hero Invoice")}
          </h1>
          <div style={{ color: "gray" }}>
            {faqItems.map((item, index) => (
              <FAQItem
                key={index}
                question={item.question}
                answer={item.answer}
              />
            ))}
          </div>
        </div>
      </Container>

      <div className="footer">
        <div className="footer-divider"></div>
        <Navbar expand="lg" className="px-3 pt-3">
          {/* Left: Logo */}
          <Navbar.Brand href="#">
            <img
              src={topLogo}
              alt="Logo"
              width="160"
              height="40"
              className="d-inline-block align-center"
            />
          </Navbar.Brand>

          {/* Center-Right: Menu Items */}
          <Nav className="ms-auto me-3">
            <Nav.Link as={Link} to="/imprint" className="text-gray">
              {t("Imprint")}
            </Nav.Link>
            <Nav.Link className="d-none d-lg-block">|</Nav.Link>
            <Nav.Link as={Link} to="/terms" className="text-gray">
              {t("Terms of Use")}
            </Nav.Link>
            <Nav.Link className="d-none d-lg-block">|</Nav.Link>
            <Nav.Link as={Link} to="/privacy" className="text-gray">
              {t("Privacy Policy")}
            </Nav.Link>
            <Nav.Link className="d-none d-lg-block">|</Nav.Link>
            <Nav.Link as={Link} to="/contact-us" className="text-gray">
              {t("Contact")}
            </Nav.Link>
          </Nav>
        </Navbar>
      </div>
    </div>
  );
};

export default LearnMore;
